module.exports = __webpack_public_path__ + "static/media/017-Fenster_schliessen_ID_2.50b2e161.mp3";